import type { CastPortrait } from './castPortraits.ts'
import { batch50Seeds } from './castBatch50DataV2.ts'

// Populated only with identity-checked, creator-controlled public posts.
export type Batch50SocialSeed = {
  personId: string
  platform: 'tiktok' | 'instagram'
  handle: string
  profileUrl: string
  postUrl: string
  postId: string
  mediaKind: 'video' | 'photo'
  accessibilitySummary: string
  verificationBasis: string
  focusY?: number
}

export const batch50SocialSeeds: Batch50SocialSeed[] = [
  {
    personId: 'p-rosemarie-vega',
    platform: 'tiktok',
    handle: '@rosevega_official',
    profileUrl: 'https://www.tiktok.com/@rosevega_official',
    postUrl: 'https://www.tiktok.com/@rosevega_official/video/7242943958924512517',
    postId: '7242943958924512517',
    mediaKind: 'video',
    accessibilitySummary: 'A close solo selfie of Rose outdoors in daylight, with her face and shoulders filling the frame.',
    verificationBasis: 'Creator profile identifies Rose as a 90 Day Fiancé alumna; the selected post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-loren-goldstone',
    platform: 'tiktok',
    handle: '@lorenbrovarnik',
    profileUrl: 'https://www.tiktok.com/@lorenbrovarnik',
    postUrl: 'https://www.tiktok.com/@lorenbrovarnik/video/7679575188979141919',
    postId: '7679575188979141919',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo head-and-shoulders frame of Loren seated indoors in a black top.',
    verificationBasis: 'Creator profile and public identity hubs match Loren Brovarnik; the selected post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-kenneth-niedermeier',
    platform: 'tiktok',
    handle: '@kennyandarmando',
    profileUrl: 'https://www.tiktok.com/@kennyandarmando',
    postUrl: 'https://www.tiktok.com/@kennyandarmando/video/7467603572285345067',
    postId: '7467603572285345067',
    mediaKind: 'video',
    accessibilitySummary: 'A solo medium portrait of Kenny seated in a car, wearing glasses and a dark pullover.',
    verificationBasis: 'The verified joint creator account is linked from the couple’s first-party identity hub; the post passed a live TikTok oEmbed check.',
    focusY: 35,
  },
  {
    personId: 'p-armando-rubio',
    platform: 'tiktok',
    handle: '@kennyandarmando',
    profileUrl: 'https://www.tiktok.com/@kennyandarmando',
    postUrl: 'https://www.tiktok.com/@kennyandarmando/video/7671454663350226206',
    postId: '7671454663350226206',
    mediaKind: 'video',
    accessibilitySummary: 'A solo medium close-up of Armando speaking indoors in glasses and a green shirt.',
    verificationBasis: 'The verified joint creator account is linked from Armando’s first-party identity hub; the post passed a live TikTok oEmbed check.',
    focusY: 35,
  },
  {
    personId: 'p-kalani-faagata',
    platform: 'tiktok',
    handle: '@kalanifaagata',
    profileUrl: 'https://www.tiktok.com/@kalanifaagata',
    postUrl: 'https://www.tiktok.com/@kalanifaagata/video/7267654447361215787',
    postId: '7267654447361215787',
    mediaKind: 'video',
    accessibilitySummary: 'A close solo selfie of Kalani reclining indoors, with her face and upper chest filling the frame.',
    verificationBasis: 'Kalani’s first-party identity hub links the account; the selected post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-asuelu-pulaa',
    platform: 'tiktok',
    handle: '@asuelu95',
    profileUrl: 'https://www.tiktok.com/@asuelu95',
    postUrl: 'https://www.tiktok.com/@asuelu95/video/7477710948648766766',
    postId: '7477710948648766766',
    mediaKind: 'video',
    accessibilitySummary: 'A solo medium portrait of Asuelu at an indoor event in a dark graphic shirt.',
    verificationBasis: 'The creator account is cross-linked by established cast accounts; the selected post passed a live TikTok oEmbed check.',
    focusY: 40,
  },
  {
    personId: 'p-niles-valentine',
    platform: 'tiktok',
    handle: '@niles_valentine',
    profileUrl: 'https://www.tiktok.com/@niles_valentine',
    postUrl: 'https://www.tiktok.com/@niles_valentine/video/7555484615822085390',
    postId: '7555484615822085390',
    mediaKind: 'video',
    accessibilitySummary: 'A bright, tightly framed solo portrait of Niles smiling in glasses against a lime-green background.',
    verificationBasis: 'The creator profile identifies Niles as a 90 Day Fiancé cast member; the selected post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-faith-gatoc-tulod',
    platform: 'tiktok',
    handle: '@faith90day',
    profileUrl: 'https://www.tiktok.com/@faith90day',
    postUrl: 'https://www.tiktok.com/@faith90day/video/7443713057978682679',
    postId: '7443713057978682679',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo close-up portrait of Faith outdoors, facing the camera with long dark hair.',
    verificationBasis: 'The creator profile identifies Faith and her Before the 90 Days season; the selected post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-veah-netherton',
    platform: 'tiktok',
    handle: '@veah90day',
    profileUrl: 'https://www.tiktok.com/@veah90day',
    postUrl: 'https://www.tiktok.com/@veah90day/video/7542645802942876983',
    postId: '7542645802942876983',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo portrait of Veah speaking to the camera from a car, with her face and long hair visible.',
    verificationBasis: 'The creator profile identifies Veah as 90 Day Fiancé cast; the selected post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-tiffany-franco',
    platform: 'tiktok',
    handle: '@tiffanyfranco__',
    profileUrl: 'https://www.tiktok.com/@tiffanyfranco__',
    postUrl: 'https://www.tiktok.com/@tiffanyfranco__/video/7614971722600647967',
    postId: '7614971722600647967',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo close-up portrait of Tiffany smiling toward the camera.',
    verificationBasis: 'The creator profile identifies Tiffany as 90 Day cast; the selected post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-tania-maduro',
    platform: 'tiktok',
    handle: '@lifewithtania_',
    profileUrl: 'https://www.tiktok.com/@lifewithtania_',
    postUrl: 'https://www.tiktok.com/@lifewithtania_/video/7689200616291241229',
    postId: '7689200616291241229',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo close-up portrait of Tania facing the camera.',
    verificationBasis: 'Tania’s creator website links the account; the selected post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-darcey-silva',
    platform: 'tiktok',
    handle: '@darceysilva',
    profileUrl: 'https://www.tiktok.com/@darceysilva',
    postUrl: 'https://www.tiktok.com/@darceysilva/video/7691406236406844686',
    postId: '7691406236406844686',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo glam portrait of Darcey, centered and facing the camera.',
    verificationBasis: 'Darcey’s established creator identity links the account; the selected post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-stacey-silva',
    platform: 'tiktok',
    handle: '@staceysilvatv',
    profileUrl: 'https://www.tiktok.com/@staceysilvatv',
    postUrl: 'https://www.tiktok.com/@staceysilvatv/video/7688627628428774670',
    postId: '7688627628428774670',
    mediaKind: 'photo',
    accessibilitySummary: 'A clear solo full-length birthday portrait of Stacey.',
    verificationBasis: 'The verified creator profile identifies Stacey and her TLC shows; the selected post passed a live TikTok oEmbed check.',
    focusY: 30,
  },
  {
    personId: 'p-david-toborowsky',
    platform: 'tiktok',
    handle: '@toborowsky_david',
    profileUrl: 'https://www.tiktok.com/@toborowsky_david',
    postUrl: 'https://www.tiktok.com/@toborowsky_david/video/7499625583677033758',
    postId: '7499625583677033758',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo close-up portrait of David speaking to the camera.',
    verificationBasis: 'The shared David and Annie creator account identifies their 90 Day shows; the post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-annie-suwan',
    platform: 'tiktok',
    handle: '@toborowsky_david',
    profileUrl: 'https://www.tiktok.com/@toborowsky_david',
    postUrl: 'https://www.tiktok.com/@toborowsky_david/video/7687361209707924766',
    postId: '7687361209707924766',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo full-body outdoor fashion portrait of Annie.',
    verificationBasis: 'The shared David and Annie creator account identifies their 90 Day shows; the post passed a live TikTok oEmbed check.',
    focusY: 25,
  },
  {
    personId: 'p-kim-menzies',
    platform: 'tiktok',
    handle: '@itskimberly90',
    profileUrl: 'https://www.tiktok.com/@itskimberly90',
    postUrl: 'https://www.tiktok.com/@itskimberly90/video/7636832418040679710',
    postId: '7636832418040679710',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo smiling close-up portrait of Kim after a hair appointment.',
    verificationBasis: 'The verified creator account is identified by published cast sources; the selected post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-usman-umar',
    platform: 'tiktok',
    handle: '@officialsojaboyy',
    profileUrl: 'https://www.tiktok.com/@officialsojaboyy',
    postUrl: 'https://www.tiktok.com/@officialsojaboyy/video/7688783708870036757',
    postId: '7688783708870036757',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo chest-up portrait of Usman seated in a car.',
    verificationBasis: 'The verified creator profile matches Usman’s established public identity; the post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-sarper-guven',
    platform: 'tiktok',
    handle: '@shekinahsarper90day',
    profileUrl: 'https://www.tiktok.com/@shekinahsarper90day',
    postUrl: 'https://www.tiktok.com/@shekinahsarper90day/video/7689912768303992072',
    postId: '7689912768303992072',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo close-up portrait of Sarper speaking to the camera.',
    verificationBasis: 'Sarper’s creator-controlled identity hub links the account; the selected post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-ashley-michelle',
    platform: 'tiktok',
    handle: '@ashleymichelle90day',
    profileUrl: 'https://www.tiktok.com/@ashleymichelle90day',
    postUrl: 'https://www.tiktok.com/@ashleymichelle90day/video/7686675904910707982',
    postId: '7686675904910707982',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo full-body portrait of Ashley standing in a kitchen.',
    verificationBasis: 'The creator profile identifies itself as Ashley’s only 90 Day account; the post passed a live TikTok oEmbed check.',
    focusY: 25,
  },
  {
    personId: 'p-nikki-sanders',
    platform: 'tiktok',
    handle: '@nikkiexotika',
    profileUrl: 'https://www.tiktok.com/@nikkiexotika',
    postUrl: 'https://www.tiktok.com/@nikkiexotika/video/7677580214519467278',
    postId: '7677580214519467278',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo bust portrait of Nikki on a yacht, with blonde hair and the sea behind her.',
    verificationBasis: 'The creator profile identifies Nikki and her 90 Day Fiancé season; the selected post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-matilda-nti',
    platform: 'tiktok',
    handle: '@iammatildanti',
    profileUrl: 'https://www.tiktok.com/@iammatildanti',
    postUrl: 'https://www.tiktok.com/@iammatildanti/video/7635748500147293458',
    postId: '7635748500147293458',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo waist-up portrait of Matilda in a dark green top, facing the camera indoors.',
    verificationBasis: 'The creator profile identifies Matilda as a 90 Day Fiancé cast member and cross-links with Niles; the post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-sam-wilson',
    platform: 'tiktok',
    handle: '@samandcitra90day',
    profileUrl: 'https://www.tiktok.com/@samandcitra90day',
    postUrl: 'https://www.tiktok.com/@samandcitra90day/video/7343820345276648722',
    postId: '7343820345276648722',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo head-and-torso portrait of Sam in glasses and a black tank top in a kitchen.',
    verificationBasis: 'The joint creator profile identifies Sam and Citra as 90 Day Fiancé season 10 cast; the selected post passed a live TikTok oEmbed check.',
  },
  {
    personId: 'p-citra-sam-arc',
    platform: 'tiktok',
    handle: '@samandcitra90day',
    profileUrl: 'https://www.tiktok.com/@samandcitra90day',
    postUrl: 'https://www.tiktok.com/@samandcitra90day/video/7691015445620509966',
    postId: '7691015445620509966',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo full-length portrait of Citra in a blue top and white pants against a pale grid background.',
    verificationBasis: 'The joint creator profile identifies Sam and Citra as 90 Day Fiancé season 10 cast; the selected post passed a live TikTok oEmbed check.',
    focusY: 25,
  },
  {
    personId: 'p-pedro-jimeno',
    platform: 'instagram',
    handle: '@pedrojosejrjimeno',
    profileUrl: 'https://www.instagram.com/pedrojosejrjimeno/',
    postUrl: 'https://www.instagram.com/p/CB5819Hg8rJ/',
    postId: 'CB5819Hg8rJ',
    mediaKind: 'photo',
    accessibilitySummary: 'A solo mirror portrait of Pedro documenting his fitness progress.',
    verificationBasis: 'Published coverage identifies Pedro’s account and this exact post; Instagram embed and image endpoints were live-checked.',
    focusY: 35,
  },
  {
    personId: 'p-zied-hakimi',
    platform: 'instagram',
    handle: '@tlc_90day_zied',
    profileUrl: 'https://www.instagram.com/tlc_90day_zied/',
    postUrl: 'https://www.instagram.com/p/CnPbk7yOvvT/',
    postId: 'CnPbk7yOvvT',
    mediaKind: 'photo',
    accessibilitySummary: 'A solo selfie of Zied in a red hoodie beside an HVAC service van on his first day of work.',
    verificationBasis: 'Published coverage identifies Zied’s account and this exact post; Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-brandon-gibbs',
    platform: 'instagram',
    handle: '@brandongibbs92',
    profileUrl: 'https://www.instagram.com/brandongibbs92/',
    postUrl: 'https://www.instagram.com/p/CwaPXmjOZTR/',
    postId: 'CwaPXmjOZTR',
    mediaKind: 'photo',
    accessibilitySummary: 'A solo travel portrait of Brandon at FIVE Palm Jumeirah Dubai.',
    verificationBasis: 'Published coverage and TLC identify Brandon’s account and this post; Instagram embed and image endpoints were live-checked.',
    focusY: 35,
  },
  {
    personId: 'p-julia-trubkina',
    platform: 'instagram',
    handle: '@juliatrubkina1993',
    profileUrl: 'https://www.instagram.com/juliatrubkina1993/',
    postUrl: 'https://www.instagram.com/p/DL4hHEcMcwt/',
    postId: 'DL4hHEcMcwt',
    mediaKind: 'photo',
    accessibilitySummary: 'A solo Hawaii vacation portrait of Julia in a swimsuit.',
    verificationBasis: 'Published coverage and TLC identify Julia’s account and this post; Instagram embed and image endpoints were live-checked.',
    focusY: 30,
  },
  {
    personId: 'p-josh-weinstein',
    platform: 'instagram',
    handle: '@jweinsteinent',
    profileUrl: 'https://www.instagram.com/jweinsteinent/',
    postUrl: 'https://www.instagram.com/p/Cwv-rb6r4hs/',
    postId: 'Cwv-rb6r4hs',
    mediaKind: 'photo',
    accessibilitySummary: 'A clear solo full-body outdoor portrait of Josh in a dark blazer and sunglasses.',
    verificationBasis: 'The verified creator account and published coverage identify Josh and this exact post; Instagram embed and image endpoints were live-checked.',
    focusY: 25,
  },
  {
    personId: 'p-ronald-smith',
    platform: 'instagram',
    handle: '@ronaldsmith_tlc',
    profileUrl: 'https://www.instagram.com/ronaldsmith_tlc/',
    postUrl: 'https://www.instagram.com/p/CTXD9jtM13V/',
    postId: 'CTXD9jtM13V',
    mediaKind: 'photo',
    accessibilitySummary: 'A clear solo close-up selfie of Ronald seated in a car, wearing sunglasses and a blue shirt.',
    verificationBasis: 'The verified creator account and published coverage identify Ronald and this exact post; Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-syngin-colchester',
    platform: 'instagram',
    handle: '@syngin_colchester',
    profileUrl: 'https://www.instagram.com/syngin_colchester/',
    postUrl: 'https://www.instagram.com/p/CXbml9CP6T9/',
    postId: 'CXbml9CP6T9',
    mediaKind: 'photo',
    accessibilitySummary: 'A clear solo close-up outdoor portrait of Syngin in warm evening light.',
    verificationBasis: 'Syngin’s creator identity hub and published coverage identify the account; Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-debbie-aguero',
    platform: 'instagram',
    handle: '@unicornrodeorider',
    profileUrl: 'https://www.instagram.com/unicornrodeorider/',
    postUrl: 'https://www.instagram.com/p/Ct9aEFvu27Q/',
    postId: 'Ct9aEFvu27Q',
    mediaKind: 'photo',
    accessibilitySummary: 'A clear solo close-up portrait of Debbie smiling in front of her artwork.',
    verificationBasis: 'Debbie’s public identity profiles and published coverage identify the account; Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-shekinah-garner',
    platform: 'instagram',
    handle: '@shekinah.guven',
    profileUrl: 'https://www.instagram.com/shekinah.guven/',
    postUrl: 'https://www.instagram.com/p/DaaZLFlxCvz/',
    postId: 'DaaZLFlxCvz',
    mediaKind: 'photo',
    accessibilitySummary: 'A clear solo three-quarter portrait of Shekinah with a bleached buzz cut and an American-flag top.',
    verificationBasis: 'Current published coverage identifies Shekinah’s creator account and this exact post; Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-tigerlily-taylor',
    platform: 'instagram',
    handle: '@tigerlilyabdelfattah',
    profileUrl: 'https://www.instagram.com/tigerlilyabdelfattah/',
    postUrl: 'https://www.instagram.com/p/DbTqC3ap74K/',
    postId: 'DbTqC3ap74K',
    mediaKind: 'video',
    accessibilitySummary: 'A clear vertical solo head-and-shoulders portrait of Tigerlily with blonde hair against a dark indoor background.',
    verificationBasis: 'Tigerlily’s verified creator profile and official site cross-link the account; Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-devin-hoofman',
    platform: 'instagram',
    handle: '@devinhoofman',
    profileUrl: 'https://www.instagram.com/devinhoofman/',
    postUrl: 'https://www.instagram.com/p/DIm6f_kMfJT/',
    postId: 'DIm6f_kMfJT',
    mediaKind: 'photo',
    accessibilitySummary: 'A clear full-length solo portrait of Devin smiling outdoors in a light blue top and a flowing white-and-blue skirt.',
    verificationBasis: 'Published cast guides identify Devin’s creator account; the exact Instagram embed and image endpoints were live-checked.',
    focusY: 25,
  },
  {
    personId: 'p-manuel-ashley-arc',
    platform: 'instagram',
    handle: '@jesusnegritovelezrojas',
    profileUrl: 'https://www.instagram.com/jesusnegritovelezrojas/',
    postUrl: 'https://www.instagram.com/p/DZfvi4Mu2Pm/',
    postId: 'DZfvi4Mu2Pm',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo vertical car portrait of Manuel wearing a backward cap and black tank top.',
    verificationBasis: 'Current published coverage identifies Manuel’s verified creator account; the exact Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-patrick-mendes',
    platform: 'instagram',
    handle: '@buffmendes',
    profileUrl: 'https://www.instagram.com/buffmendes/',
    postUrl: 'https://www.instagram.com/p/CC3THD8Jck2/',
    postId: 'CC3THD8Jck2',
    mediaKind: 'photo',
    accessibilitySummary: 'A solo full-body powerlifting portrait of Patrick under a loaded barbell in a squat rack.',
    verificationBasis: 'TLC and published cast coverage identify Patrick’s creator account and this post; Instagram embed and image endpoints were live-checked.',
    focusY: 30,
  },
  {
    personId: 'p-liz-woods',
    platform: 'instagram',
    handle: '@e_92_marie',
    profileUrl: 'https://www.instagram.com/e_92_marie/',
    postUrl: 'https://www.instagram.com/p/DC-dvCryKN9/',
    postId: 'DC-dvCryKN9',
    mediaKind: 'photo',
    accessibilitySummary: 'A solo mirror portrait of Liz in a pink sports top and black leggings.',
    verificationBasis: 'Published coverage identifies Liz’s creator account and this exact portrait; Instagram embed and image endpoints were live-checked.',
    focusY: 25,
  },
  {
    personId: 'p-alexei-brovarnik',
    platform: 'instagram',
    handle: '@alex_brovarnik',
    profileUrl: 'https://www.instagram.com/alex_brovarnik/',
    postUrl: 'https://www.instagram.com/p/C3-g6v3La3G/',
    postId: 'C3-g6v3La3G',
    mediaKind: 'photo',
    accessibilitySummary: 'A solo close-up car portrait of Alexei wearing an olive-green jacket over a dark shirt.',
    verificationBasis: 'TLC and published coverage identify Alexei’s creator account and this post; Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-jenny-slatten',
    platform: 'instagram',
    handle: '@jan_frmsan',
    profileUrl: 'https://www.instagram.com/jan_frmsan/',
    postUrl: 'https://www.instagram.com/p/B4c5xfRncpu/',
    postId: 'B4c5xfRncpu',
    mediaKind: 'photo',
    accessibilitySummary: 'A solo close-up selfie of Jenny wearing large dark-rimmed glasses.',
    verificationBasis: 'TLC and published coverage identify Jenny’s creator account and this post; Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-natalie-mordovtseva',
    platform: 'instagram',
    handle: '@nataliemordovtseva',
    profileUrl: 'https://www.instagram.com/nataliemordovtseva/',
    postUrl: 'https://www.instagram.com/p/CfsVoZ1s58W/',
    postId: 'CfsVoZ1s58W',
    mediaKind: 'photo',
    accessibilitySummary: 'A solo glam portrait of Natalie in a halter top, with a curled ponytail and smoky eye makeup.',
    verificationBasis: 'Published coverage identifies Natalie’s creator account and describes this exact portrait; Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-mike-youngquist',
    platform: 'instagram',
    handle: '@bigmike90dayfiance',
    profileUrl: 'https://www.instagram.com/bigmike90dayfiance/',
    postUrl: 'https://www.instagram.com/p/CTTXKrnFZi_/',
    postId: 'CTTXKrnFZi_',
    mediaKind: 'photo',
    accessibilitySummary: 'A selfie of Mike with his dog Nymeria; Mike’s face is clear and prominent.',
    verificationBasis: 'Published coverage identifies Mike’s creator account and this exact portrait; Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-sumit-singh',
    platform: 'instagram',
    handle: '@sumitjenny',
    profileUrl: 'https://www.instagram.com/sumitjenny/',
    postUrl: 'https://www.instagram.com/p/DBR31IfThur/',
    postId: 'DBR31IfThur',
    mediaKind: 'photo',
    accessibilitySummary: 'A creator-posted couple selfie of Sumit and Jenny, with Sumit clearly visible.',
    verificationBasis: 'The established joint creator account identifies Sumit and Jenny; the Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-igor-justin-shutencov',
    platform: 'instagram',
    handle: '@justinmoldova',
    profileUrl: 'https://www.instagram.com/justinmoldova/',
    postUrl: 'https://www.instagram.com/p/Czvt7f4og7q/',
    postId: 'Czvt7f4og7q',
    mediaKind: 'photo',
    accessibilitySummary: 'A clear solo portrait of Igor in a navy blazer and lavender shirt, seated beside a chessboard.',
    verificationBasis: 'Igor’s verified creator account links his public cast identity; the Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-adnan-abdelfattah',
    platform: 'instagram',
    handle: '@adnanabdelfattah',
    profileUrl: 'https://www.instagram.com/adnanabdelfattah/',
    postUrl: 'https://www.instagram.com/p/DMb9dbRs3Ks/',
    postId: 'DMb9dbRs3Ks',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo waist-up portrait of Adnan seated outdoors in a fitted white shirt and black overalls.',
    verificationBasis: 'Adnan’s verified creator account and Tigerlily’s reciprocal link establish identity; the Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-sunny-mahdi',
    platform: 'instagram',
    handle: '@sunny_90day',
    profileUrl: 'https://www.instagram.com/sunny_90day/',
    postUrl: 'https://www.instagram.com/p/Cxk-lFqoaSa/',
    postId: 'Cxk-lFqoaSa',
    mediaKind: 'photo',
    accessibilitySummary: 'A clear solo close-up portrait of Sunny smiling while lying on pale sand.',
    verificationBasis: 'Sunny’s creator profile identifies his Before the 90 Days season; the Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-clayton-clark',
    platform: 'instagram',
    handle: '@claytonclark90df',
    profileUrl: 'https://www.instagram.com/claytonclark90df/',
    postUrl: 'https://www.instagram.com/p/DKZ4IRvxC_g/',
    postId: 'DKZ4IRvxC_g',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo waist-up portrait of Clayton holding a microphone on a comedy-club stage.',
    verificationBasis: 'Clayton’s verified creator profile identifies his franchise credits; the Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-loren-allen',
    platform: 'instagram',
    handle: '@lorenmallen',
    profileUrl: 'https://www.instagram.com/lorenmallen/',
    postUrl: 'https://www.instagram.com/p/DdkWBnUgKB6/',
    postId: 'DdkWBnUgKB6',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo close-up selfie of Loren facing the camera indoors.',
    verificationBasis: 'Loren’s public creator profile links his franchise-specific Cameo identity; the Instagram embed and image endpoints were live-checked.',
  },
  {
    personId: 'p-anali-vallejos',
    platform: 'tiktok',
    handle: '@anali.vallejos',
    profileUrl: 'https://www.tiktok.com/@anali.vallejos',
    postUrl: 'https://www.tiktok.com/@anali.vallejos/video/7676166086567447829',
    postId: '7676166086567447829',
    mediaKind: 'video',
    accessibilitySummary: 'A clear solo close-up portrait of Analí facing the camera, with long auburn-brown hair and a black top.',
    verificationBasis: 'Analí’s public creator account matches her established Instagram identity; the selected post returned a valid TikTok oEmbed and its portrait thumbnail was visually inspected.',
  },
]

const tones: CastPortrait['tone'][] = ['berry', 'violet', 'citrus', 'coral', 'indigo', 'rose']

function displayName(name: string) {
  const quoted = name.match(/["“]([^"”]+)["”]/)?.[1]?.trim()
  return quoted || name.trim().split(/\s+/)[0] || name
}

function initials(name: string) {
  return name.replace(/["“”]/g, '').split(/\s+/).filter(Boolean).map((part) => part[0]).slice(0, 2).join('').toUpperCase()
}

export const batch50Portraits: CastPortrait[] = batch50SocialSeeds.map((social, index) => {
  const cast = batch50Seeds.find((candidate) => candidate.personId === social.personId)
  if (!cast) throw new Error(`Portrait source does not match the cast batch: ${social.personId}`)

  return {
    personId: social.personId,
    name: cast.name,
    shortName: displayName(cast.name),
    initials: initials(cast.name),
    platform: social.platform,
    handle: social.handle,
    profileUrl: social.profileUrl,
    postUrl: social.postUrl,
    postId: social.postId,
    mediaKind: social.mediaKind,
    showLabel: cast.firstShow.replace('90 Day Fiancé: ', ''),
    accessibilitySummary: social.accessibilitySummary,
    tone: tones[index % tones.length],
    focusY: social.focusY,
  }
})
